const getSession = key => {
	try {
		const currentSessionData = JSON.parse(
			localStorage.getItem("session-manager")
		);

		if (key) {
			return currentSessionData[key] ?? null;
		}

		return currentSessionData ?? null;
	} catch (err) {
		return null;
	}
};

const setSession = payload => {
	localStorage.setItem("session-manager", JSON.stringify(payload.data));

	try {
		const currentSessionData = JSON.parse(
			localStorage.getItem("session-manager")
		);

		return currentSessionData ?? null;
	} catch (err) {
		return null;
	}
};

const postUpdatesToParent = payload => {
	const iframePostData = {
		isSessionManager: true,
		type: payload.type
	};

	switch (payload.type) {
		case "setSession": {
			iframePostData.payload = setSession(payload);
			break;
		}
		default:
		case "getSession": {
			iframePostData.payload = getSession(payload.key);
			break;
		}
	}

	return window.parent.postMessage(iframePostData, "*");
};

// Only add resize listener on first load
window.addEventListener(
	"message",
	event => {
		// Ensure message event is from session manager
		if (event.data.isSessionManager) {
			postUpdatesToParent(event.data.payload);
		}
	},
	false
);
